import React from "react";

const ApplicationBtnIn: React.FC = () => {
  return (
    <svg
      id="レイヤー_1"
      data-name="レイヤー 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 96.58301 96.582"
      fill="#FFFFFFCB"
    >
      <g id="グループ_679" data-name="グループ 679">
        <g id="グループ_358" data-name="グループ 358">
          <g id="グループ_347" data-name="グループ 347">
            <path
              id="パス_1967-2"
              data-name="パス 1967-2"
              d="M54.224,108.169A48.77906,48.77906,0,0,1,11.146,65.092l2.53-.27a46.217,46.217,0,0,0,40.817,40.817Z"
              transform="translate(-11.14602 -11.58702)"
            />
            <path
              id="パス_1968-2"
              data-name="パス 1968-2"
              d="M105.199,54.935A46.219,46.219,0,0,0,64.381,14.117l.27-2.53a48.78109,48.78109,0,0,1,43.078,43.077Z"
              transform="translate(-11.14602 -11.58702)"
            />
            <path
              id="パス_1969-2"
              data-name="パス 1969-2"
              d="M13.67605,54.935l-2.53-.27A48.7811,48.7811,0,0,1,54.224,11.588l.27,2.53A46.218,46.218,0,0,0,13.67605,54.935Z"
              transform="translate(-11.14602 -11.58702)"
            />
            <path
              id="パス_1970-2"
              data-name="パス 1970-2"
              d="M64.651,108.169l-.27-2.53a46.217,46.217,0,0,0,40.818-40.818l2.53.271A48.77906,48.77906,0,0,1,64.651,108.169Z"
              transform="translate(-11.14602 -11.58702)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ApplicationBtnIn;
